import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import { StorageService } from "../services/storage-service";
import { NotifyService } from "../services/notify-service";
import { ReportService } from "../services/report-service";

export function RLReportParamSelectedCriteria() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/report-param-selected-criteria.html"),
        controllerAs: "rpscVM",
        controller: ReportParamSelectedCriteriaController,
        scope: {
            reportParameters: "=",
            reportName: "=",
            isValid: "=",
            divId: "=",
            mode: "=?",
            selectedSavedReport: "=?",
            totalSavedReports: "=?"
        },
        bindToController: true
    }

    return directive;
}

export class ReportParamSelectedCriteriaController {
    static $inject = ["$scope", "$location", "$window", "$q", "$log", "$sce", "notifyService", "storage", "reportService"];

    public reportName: string;
    public saveNewReportName: string = "";
    public divId: number;
    public mode: number;
    public reportParameters: any[];
    public loading: boolean;
    public savedReports: Models.ISavedSSRSReport[];
    public selectedSavedReport: Models.ISavedSSRSReport;
    public totalSavedReports: number;

    constructor(private $scope: Models.IReportParamSelectedCriteriaScope,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $log: ng.ILogService,
        private $sce: ng.ISCEService,
        private notifyService: NotifyService,
        private storage: StorageService,
        private reportService: ReportService) {

        this.loading = true;
        $scope.$watch(() => this.reportName, (newValue, oldValue) => {
            if (!_.isEmpty(newValue)) {
                this.loadSavedReportList();
                this.loading = false;
            }
        });
        $scope.$watch(() => this.selectedSavedReport, (newValue, oldValue) => {
            if (newValue && newValue != oldValue) {
                this.loadSavedReportList();
            }
        });

        $scope.$on('ssrsReportParamsClear', () => {
            this.selectedSavedReport = null;
            this.saveNewReportName = "";
        });
    }

    keyPressHandeler(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    private getSavedReportList() {
        this.savedReports = [];
        this.reportService.getSavedReportsList(Consts.ReportNameSpace.SSRSReports, this.reportName, Consts.IsGlobal.No)
            .then((result) => {
                if (result != null) {
                    this.savedReports = result.savedReports.sort((a, b) => a.savedReportName.localeCompare(b.savedReportName));
                    this.totalSavedReports = this.savedReports.length;
                }
            });
    }

    private loadSavedReportList() {

        if (_.isEmpty(this.reportName)) {
            return;
        }
        else {
            this.getSavedReportList();
            return;
        }
    }

    public deleteAllSavedReports() {
        if (this.$window.confirm("Are you sure you want to delete all saved reports?")) {
            this.notifyService.startProgress();
            let deleteReportForKey: Models.ISaveReportCriteria = {
                nameSpace: Consts.ReportNameSpace.SSRSReports,
                reportName: this.reportName,
                savedReports: [],
                isGlobal: Consts.IsGlobal.No,
                savedReportsJson: ""
            };

            this.reportService.deleteReportCriteria(deleteReportForKey)
                .then(() => {
                    this.getSavedReportList();
                });
        }
    }

    public onSelectedSavedReportChanged(selectedReport: Models.ISavedSSRSReport) {
        this.selectedSavedReport = selectedReport;
        return;
    }

    public saveReportParams() {
        if (_.any(this.savedReports, sv => sv.savedReportName.toLowerCase() == this.saveNewReportName.toLowerCase())) {
            alert("There is already Saved Report with this name " + this.saveNewReportName + ", Please select another report name.");
        }
        else {
            this.notifyService.startProgress();
            var reportToSave: Models.ISavedSSRSReport = {
                savedReportName: this.saveNewReportName,
                reportParameters: _.cloneDeep(this.reportParameters),
                reportParametersJson: ""
            };

            let savedReportForKey: Models.ISaveReportCriteria = {
                nameSpace: Consts.ReportNameSpace.SSRSReports,
                reportName: this.reportName,
                savedReports: [reportToSave],
                savedReportsJson: "",
                isGlobal: Consts.IsGlobal.No
            };

            this.reportService.saveReportCriteria(savedReportForKey)
                .then((result) => {
                    if (result.data) {
                        this.notifyService.notifySuccess("Successfully saved report parameters");
                    }
                    else {
                        this.notifyService.notifyError("Failed to saved report parameters");
                    }
                    this.notifyService.endProgress();
                    this.saveNewReportName = "";
                })
                .finally(() => {
                    this.selectedSavedReport = reportToSave;
                    this.getSavedReportList();
                });
        }
    }

    public deleteSelectedReport(deleteReport: Models.ISavedSSRSReport) {
        if (this.$window.confirm("Are you sure you want to delete selected report?")) {

            this.notifyService.startProgress();
            let deleteReportForKey: Models.ISaveReportCriteria = {
                nameSpace: Consts.ReportNameSpace.SSRSReports,
                reportName: this.reportName,
                savedReports: [deleteReport],
                isGlobal: Consts.IsGlobal.No,
                savedReportsJson: ""
            };

            this.reportService.deleteReportCriteria(deleteReportForKey)
                .then((result) => {
                    if (result.data) {
                        if (this.selectedSavedReport != undefined && deleteReport.savedReportName == this.selectedSavedReport.savedReportName) {
                            this.selectedSavedReport = null;
                        }

                        this.notifyService.notifySuccess(deleteReport.savedReportName + " has been deleted.");
                    }
                    else {
                        this.notifyService.notifyError("Failed to delete report " + deleteReport.savedReportName);
                    }
                    this.notifyService.endProgress();
                    this.saveNewReportName = "";
                })
                .finally(() => {
                    this.getSavedReportList();
                });
        }
    }
}
